export const EkAccountantsServiceList = [
    "BAS Lodgement",
    "Bookkeeping",
    "Company Tax Return",
    "Personal Tax Return",
    "Business Registration"
]